import { render, staticRenderFns } from "./UserTableHeader.vue?vue&type=template&id=0b6a81b4"
import script from "./UserTableHeader.vue?vue&type=script&lang=js"
export * from "./UserTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports